import { ShortcodeFn } from 'components/vendor/Contentful/richText/ShortcodeManager'
import MultiProductWidget from 'components/vendor/MultiProductWidget/MultiProductWidget'

const normalizeEmbedArgumentStrings = (attrs: Record<string, string>): Record<string, string> => {
	const parsed: Record<string, string | undefined> = {}

	Object.keys(attrs).forEach(key => {
		if (key.indexOf('maxResults') > -1) {
			parsed[key.replace('_', '.')] = attrs[key]
		} else {
			parsed[key.replace('__', '.')] = attrs[key]
		}
	})

	return parsed as Record<string, string>
}

const embedsConfig: Record<string, any> = {
	embedCreditCard: {
		access_token: 'cdbaf213-b7d7-45b9-95b0-8ba1a0b1debe_919f1225-2ead-4a45-9b5c-948791c167ff',
		available_products: 'credit_card',
		company_uuid: '6edf7cfb-c439-4ead-9b42-cbb87350ff3',
		partner: 'fiona_cc'
	},
	embedInsurance: {
		access_token: '0e1a6635-55a0-4df1-89e2-7bfc6f8e75ba_1d3048d3-c085-414a-a226-825bf1ff63ba',
		available_products: 'life_insurance',
		company_uuid: 'c9eae6d4-5187-4337-979a-c3ea54698600'
	},
	embedTabbed: {
		access_token: '1290ba3b-af18-415d-82d5-77ee13945b53_05fb4ebd-fb88-4ce1-a934-1d4937128374',
		company_uuid: '08f5e428-f79f-4c41-b7a1-2aa0aff8734c'
	},
	embed: {
		access_token: '0b775b50-7247-4c92-b499-dde844d275ed_fe3a2338-372d-409d-bac2-4b94edc76acd',
		available_products: 'loan',
		company_uuid: 'f4f363d7-086b-4fcf-86e5-58a4284e05b6',
		partner: 'fiona'
	},
	embedSavings: {
		access_token: '701a1b86-a217-43cb-8cd4-39d38549cfe5_ea78268b-172d-43ad-99a9-291d475a1516',
		available_products: 'deposits',
		company_uuid: 'aaac14ee-2db6-4a16-9759-35424e86a25d'
	}
}

const evenEmbedShortcode: ShortcodeFn = (name, attrs) => {
	const parsed = normalizeEmbedArgumentStrings(attrs)
	const config = embedsConfig[name]
	const partner = parsed['partner'] || config.partner
	return (
		<MultiProductWidget
			key={partner}
			product={config.available_products}
			partner={partner}
			override={{ ...config, ...parsed }}
		/>
	)
}

export const embedShortcodes = (): Record<string, ShortcodeFn> => {
	const config: Record<string, ShortcodeFn> = {}
	Object.keys(embedsConfig).forEach(name => Object.assign(config, { [name]: evenEmbedShortcode }))
	return config
}
